import angular from 'angular';

import { ParametersTagEditionController } from './parameters.tag.edition.controller.js';
import { ParametersCategoryEditionController } from './parameters.category.edition.controller.js';
import { ParametersTagGroupAddController } from './parameters.tag-group.add.controller.js';
import { ParametersTagsGroupsController } from './parameters.tags-groups.controller.js';
import { ParametersTagGroupController } from './parameters.tag-group.controller.js';

angular
  .module('parameters.tags', ['ui.bootstrap', 'ui.sortable'])
  .value('MAX_TAG_GROUP_NUMBER', 8)
  .controller('ParametersCategoryEditionController', ParametersCategoryEditionController)
  .controller('ParametersTagEditionController', ParametersTagEditionController)
  .controller('ParametersTagsGroupsController', ParametersTagsGroupsController)
  .controller('ParametersTagGroupController', ParametersTagGroupController)
  .controller('ParametersTagGroupAddController', ParametersTagGroupAddController);
